/* eslint-disable react/no-array-index-key */
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useIsMobile } from '@stores/AppCommonData';
import { sectionsIds } from '../sections';
import { Spacings, Fonts } from '../../../../styleConstants';
import SectionTitle from '../SectionTitle';
import SectionDescription from '../SectionDescription';
import SectionContainer from '../SectionContainer';

const SectionInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr ${({ $isMobile }) => ($isMobile ? '' : '1fr')};
  grid-column-gap: 136px;
  grid-row-gap: ${({ $isMobile }) =>
    $isMobile ? Spacings.SPACING_10B : Spacings.SPACING_20B};
`;

const FaqContainer = styled.div``;

const StyledDescription = styled(SectionDescription)`
  margin-top: ${({ $marginTop }) => $marginTop};
`;

const SummitFaqs = ({ headerRefs }) => {
  const isMobileDevice = useIsMobile();
  let questionStyle = {
    fontSize: Fonts.H1,
    lineHeight: Fonts.PARA_LINE_HEIGHT
  };
  let answerStyle = {
    fontSize: Fonts.H3,
    marginTop: Spacings.SPACING_10B
  };
  if (isMobileDevice) {
    questionStyle = {
      fontSize: Fonts.H3,
      lineHeight: '30px'
    };
    answerStyle = {
      fontSize: Fonts.H5,
      marginTop: Spacings.SPACING_4B
    };
  }
  const faqs = useSelector(({ summit }) => summit.faqs || []);
  return (
    <SectionContainer
      title="FAQs"
      color="var(--color-i-green-3)"
      sectionId={sectionsIds.faqs}
      contentMarginTop={isMobileDevice ? Spacings.SPACING_10B : '18px'}
      headerRefs={headerRefs}
      hideSectionInfo
    >
      <SectionInfo $isMobile={isMobileDevice}>
        {faqs.map((faq, index) => (
          <FaqContainer key={index}>
            <SectionTitle
              $size={questionStyle.fontSize}
              $lineHeight={questionStyle.lineHeight}
            >
              {faq.question}
            </SectionTitle>
            <StyledDescription
              $size={answerStyle.fontSize}
              $marginTop={answerStyle.marginTop}
            >
              {faq.answer}
            </StyledDescription>
          </FaqContainer>
        ))}
      </SectionInfo>
    </SectionContainer>
  );
};

SummitFaqs.propTypes = {
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired
};

export default SummitFaqs;
